<template>
  <div id="team-members-modifiy">
    <overlay-loading-progress :LoadingFlag="OverlayLoadingFlag" />
    <v-dialog v-model="memberDocumentPrompt" persistent scrollable>
      <upload-selected-member-document
        :record="member"
        v-if="memberDocumentPrompt"
        :showDialog="memberDocumentPrompt"
        @hideDialog="hideMemberDocumentPrompt($event)"
      ></upload-selected-member-document>
    </v-dialog>
    <v-dialog v-model="memberPhotoPrompt" persistent scrollable max-width="75%">
      <upload-selected-member-photo
        :record="member"
        v-if="memberPhotoPrompt"
        :showDialog="memberPhotoPrompt"
        @hideDialog="hideMemberPhotoPrompt($event)"
      ></upload-selected-member-photo>
    </v-dialog>
    <v-card style="height: 100vh; width: 100vw; overflow-y: auto">
      <v-app-bar
        color="primary"
        dense
        dark
        elevate-on-scroll
        scroll-target="#scrolling-techniques-7"
      >
        <v-toolbar-title> {{ PageTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closePrompt">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-form ref="form1" v-model="valid1" lazy-validation id="createForm">
        <v-card-text style="height: 70%">
          <v-container class="py-0">
            <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
              <b-spinner
                variant="primary"
                type="grow"
                label="Loading..."
              ></b-spinner>
            </div>
            <v-container v-if="StartupLoadingFlag">
              <v-row wrap>
                <v-col cols="12" md="4" v-for="n in 6" :key="n">
                  <v-skeleton-loader
                    v-bind="attrs"
                    type="paragraph"
                  ></v-skeleton-loader>
                </v-col>
              </v-row>
            </v-container>
            <v-row wrap v-if="ProgessStart == 1">
              <v-col align="center" cols="12" md="12">
                <v-progress-circular
                  :rotate="180"
                  :size="100"
                  :width="15"
                  :value="uploadPercentage"
                  color="#00a4ef"
                >
                  {{ uploadPercentage }}
                </v-progress-circular>
                <h3 class="red--text">
                  Please wait, we are uploading your details. Time may vary
                  based on your internet connection.
                </h3>
              </v-col>
            </v-row>
          </v-container>
          <v-container v-if="!StartupLoadingFlag">
            <v-row wrap>
              <v-col cols="12" md="6">
                <label>
                  <h6><span class="text-danger">*</span> Select Designation</h6>
                </label>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :items="DesignationOptions"
                  :rules="DesignationRules"
                  :loading="DesignationOptionsLoading"
                  v-model="Designation"
                  :item-value="'value'"
                  :item-text="'text'"
                  dense
                  clearable
                  required
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label>
                  <h6><span class="text-danger">*</span> Select Member</h6>
                </label>
                <v-autocomplete
                  @change="getMemberRecords"
                  :reduce="(option) => option.value"
                  :loading="MemberIdOptionsLoading"
                  :items="MemberIdOptions"
                  :rules="MemberIdRules"
                  v-model="MemberId"
                  required
                  outlined
                  dense
                  clearable
                >
                  <!-- :disabled="index == 0 ? true : false" -->
                  <template v-slot:selection="{ item }">
                    <img width="50" height="50" :src="item.photo" />{{
                      item.text
                    }}
                  </template>
                  <template v-slot:item="{ item }">
                    <img width="50" height="50" :src="item.photo" />{{
                      item.text
                    }}
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>

            <v-row v-if="MemberId > 0">
              <v-col cols="12" sm="12" md="12" class="text-center">
                <img width="100" height="auto" :src="member.Photo" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label>Member Name</label>
                <h5>{{ member.MemberName }}</h5>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label>Membership Id</label>
                <h5>{{ member.MembershipId }}</h5>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label>Mobile No</label>
                <h5>{{ member.MobileNo }}</h5>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label>Email Id</label>
                <h5>{{ member.EmailId }}</h5>
              </v-col>
              <v-col cols="12" sm="6" md="8">
                <label>Address</label>
                <h5>{{ member.AddressTxt }}</h5>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <label>Date of Birth</label>
                <h5>{{ member.MemberDOB || "NA" }}</h5>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <h4>Profile Update</h4>
                <v-chip
                  :color="`${
                    member.ProfileUpdated == 1 ? '#0f9d58' : '#f4b400'
                  }`"
                  draggable
                  dark
                  >{{ member.ProfileUpdated == 1 ? "Completed" : "Pending" }}
                </v-chip>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <h4>Photo Update</h4>
                <v-chip
                  :color="`${member.PhotoFlag ? '#0f9d58' : '#f4b400'}`"
                  draggable
                  dark
                  >{{ member.PhotoFlag ? "Completed" : "Pending" }}
                </v-chip>
                &nbsp;
                <v-icon
                  icon
                  size="25px"
                  color="primary"
                  @click.prevent="memberPhotoPrompt = true"
                  v-if="member.PhotoFlag == false"
                >
                  mdi-cloud-upload
                </v-icon>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <h4>Aadhar verification</h4>
                <v-chip :color="`${member.AadhaarTextColor}`" draggable dark
                  >{{ member.AadhaarVerifiedTxt }}
                </v-chip>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <h4>Subscription Validation</h4>
                <v-chip
                  :color="`${
                    member.MemberDueCountFlag ? '#0f9d58' : '#FF0000'
                  }`"
                  draggable
                  dark
                  >{{ member.MemberDueCountFlag ? "Eligible" : "Not Eligible" }}
                </v-chip>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <br /><br />
        <v-card-actions>
          <v-row justify="center" class="w-100">
            <v-btn
              :disabled="!(valid1 && member.SubmitButtonFlag)"
              @click.prevent="confirmAlert"
              :loading="SubmitFlag"
              elevation="30"
              shaped
              tile
              small
              color="primary"
              class="font-size-h6 px-10 mr-3 white--text"
            >
              submit
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import UploadSelectedMemberDocument from "@/view/pages/members/UploadSelectedMemberDocument.vue";
import UploadSelectedMemberPhoto from "@/view/pages/members/UploadSelectedMemberPhoto.vue";

export default {
  mixins: [common],
  components: {
    UploadSelectedMemberDocument,
    UploadSelectedMemberPhoto,
  },
  props: {
    addRecordPrompt: {
      type: Boolean,
      required: true,
    },
    pageDescription: {
      type: String,
    },
    LomCode: {
      type: Number,
    },
  },
  data() {
    return {
      valid1: true,

      search: "",
      selected: [],
      tableSelectFlag1: false,
      SubmitFlag: false,
      ResultFlag: false,

      member: {},

      DesignationOptions: [],
      DesignationRules: [(v) => !!v || "Designation is required"],
      DesignationOptionsLoading: false,
      Designation: "", // not null or undefined

      memberDocumentPrompt: false,
      memberPhotoPrompt: false,

      rows: [],
      tableColumns1: [],
      records: [],

      alert: {},

      ProgessStart: 0,
      uploadPercentage: 0,

      SuccessMessageTxtFlag: 0,
      SuccessMessageTxt: "",

      ErrorMessageTxtFlag: 0,
      ErrorMessageTxt: "",

      ResultFlag: false,
      LoadingFlag: false,
      OverlayLoadingFlag: false,
      StartupLoadingFlag: false,

      AllMembers: [],

      YearCodeRules: [(v) => !!v || "Year is required"],
      YearCode: "",
      YearCodeOptions: [],
      YearCodeOptionsLoading: false,

      TeamCodeRules: [(v) => !!v || "Team is required"],
      TeamCode: "",
      TeamCodeOptions: [],
      TeamCodeOptionsLoading: false,

      ZoneCodeRules: [(v) => !!v || "Zone is required"],
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      MemberIdRules: [(v) => !!v || "Member is required"],
      MemberId: "",
      MemberIdOptions: [],
      MemberIdOptionsLoading: false,

      MemberNameRules: [(v) => !!v || "Member Name is required"],
      MemberName: "",

      EmailIdRules: [],
      EmailId: "",

      MobileNoRules: [],
      MobileNo: "",

      Address: "",

      CityNameRules: [],
      CityName: "",

      uploadedImages: [],

      FacebookRules: [],
      Facebook: "",

      TwitterRules: [],
      Twitter: "",

      InstagramRules: [],
      Instagram: "",

      MemberTypeId: "",

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.pageData();
      }
    },
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    rows: function () {
      console.log("watch rows");
      var n1 = this.rows.length;
      var flag = n1 == 0 ? 0 : 1;
      console.log("n1=" + n1 + ", flag=" + flag);
      this.records = this.rows[0];
    },
    YearCodeOptions: function () {
      this.YearCodeOptionsLoading = false;
    },
    TeamCodeOptions: function () {
      this.TeamCodeOptionsLoading = false;
    },
    ZoneCodeOptions: function () {
      this.ZoneCodeOptionsLoading = false;
    },
    MemberIdOptions: function () {
      this.MemberIdOptionsLoading = false;
    },
    DesignationOptions: function () {
      console.log("watch Designation");
      this.DesignationOptionsLoading = false;
      this.LoadingFlag = false;
    },
    Designation: function () {
      console.log("watch Designation");
      var Designation = this.Designation;
      if (Designation != "") {
        var MemberTypeId = "";
        switch (Designation) {
          case 14:
            // Junior Jaycee Wing
            MemberTypeId = 9;
            break;

          case 15:
            // Jayceert Wing
            MemberTypeId = 8;
            break;

          default:
            MemberTypeId = 1;
            break;
        }
        this.MemberTypeId = MemberTypeId;
        this.getMemberIdOptions();
      }
    },
    MemberId: function () {
      console.log("watch MemberId");
      var temp_code = this.MemberId;
      console.log("temp_code=" + temp_code);
      var idx = this.MemberIdOptions.map((e) => e.value).indexOf(temp_code);
      console.log("idx=" + idx);
      if (idx >= 0) {
        var member = this.MemberIdOptions[idx];
        console.log({ member });
      }
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    hideMemberDocumentPrompt(flag) {
      console.log("hideMemberDocumentPrompt called");
      console.log({ flag });
      this.memberDocumentPrompt = false;
      if (flag) {
        this.member.document_flag = true;
      }
    },
    hideMemberPhotoPrompt(flag) {
      console.log("hideMemberPhotoPrompt called");
      console.log({ flag });
      this.memberPhotoPrompt = false;
      if (flag) {
        this.member.photo_flag = true;
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "nominate_member",
        Action: "create",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      console.log("LomCode=" + this.LomCode);
      console.log("ZoneCode=" + this.ZoneCode);

      this.getDesignationOptions();
    },
    getMemberRecords() {
      console.log("getMemberRecords called");

      var MemberId = this.MemberId;
      console.log({ MemberId });

      this.OverlayLoadingFlag = true;

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/nominate-member-subscription/info";
      var upload = {
        UserInterface: 1,
        Member: MemberId,
        Designation: this.Designation,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );
      console.log("recordData:", this.recordData);

      const thisIns = this;
      var output = "";
      var records = {};
      var flag = 0;
      var data = {};

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          // thisIns.pageLoadingOff()
          thisIns.OverlayLoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);

          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.member = records;
            // thisIns.toast("success", output);
          } else {
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.OverlayLoadingFlag = false;
        });
    },
    getDesignationOptions() {
      console.log("getDesignationOptions called");
      const selectbox1_source = "Designation";
      const selectbox1_destination = "DesignationOptions"; // must match autocomplete items
      const selectbox1_url = "api/nomination-designation/options";
      const selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    validate() {
      console.log("validate called");
      this.$refs.form1.validate();
    },
    reset() {
      console.log("reset called");
      this.$refs.form1.reset();
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideAddRecordPrompt", this.ResultFlag);
    },
    getMemberDetails() {
      console.log("getMemberDetails called");
      var temp_code = this.MemberId;
      console.log("temp_code=" + temp_code);
      var idx = this.MemberIdOptions.map((e) => e.value).indexOf(temp_code);
      console.log("idx=" + idx);
      if (idx >= 0) {
        var member = this.MemberIdOptions[idx];
        console.log("member=" + JSON.stringify(member));
        this.member = member;
      }
    },
    resetMessageTxt() {
      console.log("resetMessageTxt called");
      this.ErrorMessageTxt = 0;
      this.ErrorMessageTxtFlag = "";
      this.SuccessMessageTxtFlag = 0;
      this.SuccessMessageTxt = "";
    },
    onFileSelected(event, k) {
      console.log("onFileSelected called");
      var n1 = this.uploadedImages.length;
      var file = event.target.files[0];
      console.log("k=" + k + ", event=" + JSON.stringify(file));
      this.uploadedImages[k] = file;
    },
    addNewRow(tableId) {
      console.log("addNewRow called");
      console.log("tableId=" + tableId);

      if (tableId == 2) {
        var n1 = this.AllMembers.length;
        console.log("n1=" + n1);
        // if (n1 < 30) {
        this.AllMembers.push({
          YearwiseOfficesHeldId: null,
          MemberId: 0,
          MemberName: "",
          Designation: 0,
          Designation: "",
        });
        // }
      }
    },
    deleteRow(tableId, index, tr) {
      console.log("deleteRow called");
      console.log(
        "tableId=" + tableId + ", index=" + index + ", tr=" + JSON.stringify(tr)
      );
      if (index > -1) {
        if (tableId == 2) {
          this.AllMembers.splice(index, 1);
        }
      }
    },
    getMemberIdOptions() {
      console.log("getMemberIdOptions called");
      this.MemberIdOptionsLoading = true;
      var selectbox1_source = "MemberId";
      var selectbox1_destination = "MemberIdOptions";
      var selectbox1_url = "api/members/options";
      var selectbox1_conditions_array = {
        UserInterface: 7,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        this.toast("error", "Kindly fill the required fields", true);
      }
    },
    submitForm() {
      // add todo in store and clear all fields in dialog
      console.log("submitForm called");

      // this.resetMessageTxt();

      var result = this.$refs.form1.validate();
      console.log("result=" + result);

      if (result) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/nomination-member/store";
        var upload = {
          UserInterface: 1,
          Designation: this.Designation,
          Member: this.MemberId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.OverlayLoadingFlag = true;

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        // thisIns.pageLoadingOn()

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            // thisIns.ProgessStart = 0;
            thisIns.OverlayLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.ResultFlag = true;
              thisIns.closePrompt();
              // thisIns.AllMembers = [];
              // thisIns.ResultFlag = false;
              thisIns.sweetAlert("success", output, true);
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.OverlayLoadingFlag = false;
          });
      } else {
        console.log("some errors occured");
        var message = "";
        if (LomCode == "") {
          message += "LO should not be empty. ";
        }
        if (MemberId == "") {
          message += "Member should not be empty. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    console.log("beforeMount called");
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
#team-members-modifiy {
  .v-dialog > .v-card > .v-toolbar {
    position: sticky;
    top: 0;
    z-index: 999;
  }
}
</style>